import React from "react";

const SketchfabSingleModel = (props) => {
  return (
    <>
      <iframe
        title="Low"
        frameBorder="0"
        allowFullScreen
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        xr-spatial-tracking ="true"
        execution-while-out-of-viewport="true"
        execution-while-not-rendered="true"
        web-share="true"
        src={`https://sketchfab.com/models/${props.modelId}/embed?autostart=1&ui_watermark_link=0&ui_watermark=0&ui_infos=0`}
      ></iframe>
    </>
  );
}

export default SketchfabSingleModel;
